import { render, staticRenderFns } from "./ProductRetailerLinks.vue?vue&type=template&id=4ff3373e"
import script from "./ProductRetailerLinks.vue?vue&type=script&lang=js"
export * from "./ProductRetailerLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports